// Styles for Footer go here.
import styled from 'styled-components';
import { toRem, theme } from '../../styles';

export const StyledHeader = styled.div`
  .bottomLine {
    border-bottom: 'solid ${toRem(0.5)} #646464';
  }
  .logo-container{
    padding:12px 100px;
    @media ${theme.mediaQuery.mobileTablet} {
      padding: 16px 32px 34px 16px;
    }
    picture {
      @media ${theme.mediaQuery.mobileOnly} {
        display: flex;
        align-items: center;
      }
    }
    .tablet-align{
     &.d-flex{
     @media ${theme.mediaQuery.mediumTablet} {
        display: flex;
        justify-content:center !important;
      }
    }
    }
    .text-address{
     @media ${theme.mediaQuery.mediumTablet} {
        display: flex;
        align-items: center;
        padding: 15px 15px 19px;
        border-left: 1px solid var(--t-horizontal-vertical-rule);
      }
    }
  }
  .navigation-btns {
    padding-left: 113px;
    display: flex;
    @media ${theme.mediaQuery.tabletScreenBetween} {
      padding:15px 15px 19px;
    }
    
    @media ${theme.mediaQuery.mobileTablet} {
      padding: 15px 36px 0;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    span{
        display:none
    }
      &:hover {
      
      }
    }
  }
  .popup-close {
    @media ${theme.mediaQuery.mobileTablet} {
      z-index: 9;
    }
  }
  .custom_click_track{
    @media ${theme.mediaQuery.allMobiles} {
        font-size: ${toRem(12)};
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
  .header-logo{
    max-width:159px;
    max-height: 90px;
    padding-right: 30px;
  }
  .sub-nav-container {
    padding-top: 37px;
    padding-bottom: 27px;
    padding-left: 100px;
    align-items: center;
      @media ${theme.mediaQuery.tabletScreenBetween} {
     padding-left:15px;
    }
    @media ${theme.mediaQuery.mobileTablet} {
      padding: 0;
    flex-direction: column;
    }
  }
  .text-address{
    font-size: ${toRem(22)};
    font-weight: 400;
    line-height: 22px;
    @media ${theme.mediaQuery.allMobiles} {
        font-size: ${toRem(16)};
        font-weight: 400;
        line-height: 22px;
         padding: 15px 15px 19px;
      }
    }
    h4{
      @media ${theme.mediaQuery.tabletScreenBetween} {
        max-width: 436px;
        min-width: 260px;
      }
      @media ${theme.mediaQuery.minDesktop} {
        max-width: 436px;
        min-width: 360px;
      }
    }
  }
  .nav-link-items {
    font: normal normal 400 1rem/1.25rem var(--t-base-font-family);
    color: var(--t-brand-fg-color);
    margin-left: 47px;
    opacity: 0.7;
    padding-bottom: 13px;
    border-bottom: 3px solid transparent;
    display: block;
    text-align: center;
    min-width: 48px;
    @media ${theme.mediaQuery.mobileTablet} {
      margin : 0;
      font-size:12px;
      line-height:20px;
      font-weight:400;
    }
    &:hover,
    &.active {
      opacity: 1;
      border-bottom: 3px solid var(--t-interactive-accent-color, #a9a9a9);
    }

  }
  .navigation-btns {
    .nav-link-items {
      &:nth-child(1) {
        min-width: 100px;
      }
      &:nth-child(3) {
        min-width: 91px;
      }
    }
  }
  .icon-mail:before , .icon-phone:before, .icon-globe:before ,.icon-nav---account:before{
    color:var(--t-interactive-accent-color);
    vertical-align: top;
    padding-right:8px;
    font-weight: 400;
    font-size: 16px;
    vertical-align: top;
    @media ${theme.mediaQuery.mobileTablet} {
      font-size: 14px;
    }
  }
  .icon-mail,.icon-globe,.icon-nav---account{
  margin-left: 40px;
  @media ${theme.mediaQuery.allMobiles} {
  word-break:break-all;
   margin-left:23px;
   white-space:normal;
  }
  }
  .icon-phone:before {
   position:relative;
  }
  .icon-nav---account {
    cursor: pointer; 
    background: transparent !important;
    outline: revert !important;
    min-height: 24px;
    align-items: center;
    @media ${theme.mediaQuery.allMobiles} {
      min-height: 20px;
    }
  }

  .icon-mail:before {
    top: 1px;
  }


  .icon-mail:before,.icon-globe:before ,.icon-nav---account:before {
   position:relative;
  //  top:3px;
  }
  .header-container {
    .right-container {
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: right;
      @media ${theme.mediaQuery.mobileTablet} {
        margin: 0 auto;
      }
         button, [type=button]{
            // background-color: transparent !important;
            // all: unset !important;
         }  
      a {
        white-space: nowrap;
        font-weight: normal;
        font-size:14px;
        @media ${theme.mediaQuery.mobileTablet} {
        font-size:12px;
        display:flex;
        align-items:center;
        }
        span {
          font : normal normal 400 1rem/1.25rem var(--t-base-font-family)
          @media ${theme.mediaQuery.allMobiles} {
            font: normal normal 400 0.75rem/1.25rem var(--t-base-font-family)
          }
  
          &::before {
            font-size: ${toRem(14)}
            @media ${theme.mediaQuery.allMobiles} {
              font-size: ${toRem(16)}
            }
          }
        }
      }
        .language-selector-button-footer {
    cursor: pointer;
}
    }
    .t-brand-font-l {
      font: normal normal var(--t-brand-font-l-font-weight) var(--t-subtitle-m-font-size-viewport-xs) / var(--t-brand-font-l-line-height-viewport-xs) var(--t-font-family);
    }
    
  }
  .m-accordion-container {
    padding: 0;
  }
  .no-pointer-events {
    pointer-events: none;
  }
  .text-address {
    display: flex;
    align-items: center;
     @media ${theme.mediaQuery.mobileTablet} {
      padding: 15px 15px 19px;
    line-height: 22px;
      }
  }
`;
